/* eslint-disable */
import IStat from "./IStat";
import LayerConfig from "./LayerConfig";
import LayerStyleComplex from "./LayerStyleComplex";
import StyleRule from "./style/StyleRule";

 


export type IndicatorAggregationType = 'count' | 'sum' | 'mean';

export default class Indicator {
    
    attributeName!: string;
    
    labelAttribute!: string;

    /** Attribut numérique à agréger pour chaque section du donut (sum/mean). Ignoré si aggregationType = count. */
    valueAttribute?: string;

    /** Mode de calcul de la valeur de chaque section du donut. */
    aggregationType: IndicatorAggregationType = 'count';

    /** Unité affichée avec le total au centre du donut (ex: €, hab., M€). */
    centerUnit?: string;

    /** Nombre d'objets à afficher pour graphType = top_n. */
    topCount = 5;

    textContent!: string;

    layer!:LayerConfig;

    textSelectContent!: string;

    colorPalette!: string;

    graphType!: string;

    nbColors!:number

    /** Visible dans le panneau Indicateurs (persisté). */
    active = true;

    useColorFromAnalyse=false;

    filterData:any;

    label?: string;

    /** UI only — panneau d'édition ouvert. */
    edit=false;

    /** UI only — options avancées dépliées. */
    showAdvanced=false;

    stats:any;

    showCenterObject=false;

    currentTextContent:string='';

    currentSelectContent:string='';

    chart:any;

    constructor(input: any = null) {
      if (input) {
        Object.assign(this, input);
      }
      if (!this.aggregationType) {
        this.aggregationType = 'count';
      }
      if (this.active === undefined || this.active === null) {
        this.active = true;
      }
      if (!this.topCount || this.topCount < 1) {
        this.topCount = 5;
      }
    }

    isGraph():boolean{
      return this.graphType !== 'textarea' && this.graphType !== 'top_n';
    }
    isTextArea():boolean{
      return this.graphType=="textarea";
    }
    isTopN():boolean{
      return this.graphType === 'top_n';
    }

    usesValueAggregation(): boolean {
      return this.aggregationType === 'sum' || this.aggregationType === 'mean';
    }

    isVisible(): boolean {
      return this.active !== false;
    }

    getGraphTypeLabel(): string {
      if (this.graphType === 'distinct_donut') {
        return 'Donut';
      }
      if (this.graphType === 'minmaxmean') {
        return 'Barres min/max/moy.';
      }
      if (this.graphType === 'textarea') {
        return 'Zone de texte';
      }
      if (this.graphType === 'top_n') {
        return 'Top objets';
      }
      return this.graphType || 'Indicateur';
    }

    getSummary(): string {
      if (!this.graphType || !this.attributeName) {
        return '';
      }
      if (this.graphType === 'distinct_donut') {
        if (!this.usesValueAggregation()) {
          return `Nombre d'objets par « ${this.attributeName} »`;
        }
        const valueName = this.valueAttribute || 'valeur';
        const calc = this.aggregationType === 'sum' ? 'Somme' : 'Moyenne';
        return `${calc} de « ${valueName} » par « ${this.attributeName} »`;
      }
      if (this.graphType === 'minmaxmean') {
        return `Minimum, maximum et moyenne de « ${this.attributeName} »`;
      }
      if (this.graphType === 'textarea') {
        return `Texte avec statistiques sur « ${this.attributeName} »`;
      }
      if (this.graphType === 'top_n') {
        const n = this.topCount || 5;
        const labelName = this.labelAttribute || 'label';
        return `Top ${n} objets par « ${this.attributeName} » (libellé : ${labelName})`;
      }
      return '';
    }
    
    computeStats(features: any,layer:LayerConfig) {
      if(this.graphType=="minmaxmean"){
        if(features && features.length>0){
          this.stats=this.getMinMaxMeanStats(features, this.attributeName);
        }else{
          this.stats={min:0,max:0,mean:0,count:0,sum:0};
        }
   
      }
      else if(this.graphType=="textarea"){
        if(features && features.length>0){
          this.stats=this.getMinMaxMeanStats(features, this.attributeName);
        }else{
          this.stats={min:0,max:0,mean:0,count:0,sum:0};
        }
        this.currentTextContent=this.replaceContent(this.textContent || '',this.stats);
        
      }
      else if(this.graphType=="top_n"){
        if(features && features.length>0){
          this.stats=this.getTopNStats(features, layer);
        }else{
          this.stats=[];
        }
      }
      else{
        if(features && features.length>0){
          if(this.useColorFromAnalyse){
            this.stats=this.getCountStatsBasedOnAnalyse(features, this.attributeName,layer.complexStyle);
          }else{
            this.stats=this.getCountStats(features, this.attributeName);
          }
        }else{
          this.stats=[];
        }
      }
    }

    replaceContent(content:string,stats:any,feature?:any):string{
      console.log(stats);
      content=content.replace('{MAX}',stats.max);
      content=content.replace('{MIN}',stats.min);
      content=content.replace('{MEAN}',stats.mean);
      content=content.replace('{COUNT}',stats.count);
      if(feature){
        content=content.replace('{LABEL}',feature.get(this.labelAttribute));
        content=content.replace('{VALUE}',feature.get(this.attributeName));
      }
      return content;
    }

    private getFeatureNumericValue(item: any): number | null {
      if (!this.valueAttribute) {
        return null;
      }
      const raw = item.get(this.valueAttribute);
      const value = Number(raw);
      return Number.isFinite(value) ? value : null;
    }

    private finalizeAggregatedStat(stat: {
      title: string;
      count: number;
      sum: number;
      numericCount: number;
      value: number;
    }) {
      if (this.aggregationType === 'sum') {
        stat.value = +stat.sum.toFixed(2);
      } else if (this.aggregationType === 'mean') {
        stat.value = stat.numericCount > 0 ? +(stat.sum / stat.numericCount).toFixed(2) : 0;
      } else {
        stat.value = stat.count;
      }
      return stat;
    }

    private getRuleColor(rule: StyleRule): string {
      const style: any = rule && rule.style;
      if (!style) {
        return '#cccccc';
      }
      const fillColor = style.fillStyle && typeof style.fillStyle.getFillColor === 'function'
        ? style.fillStyle.getFillColor()
        : (style.fillStyle && style.fillStyle.fillColor);
      return fillColor
        || (style.pointSymbol && style.pointSymbol.symbolFillColor)
        || (style.strokeStyle && style.strokeStyle.color)
        || '#cccccc';
    }

    getCountStatsBasedOnAnalyse(features: any, attributeName: string,complexAnalyse:LayerStyleComplex) {
      // Exclure les règles "taille seule" (ex: classes de population) pour ne garder
      // que les règles qui portent une couleur (ex: categories).
      const colorRules = typeof complexAnalyse.getColorRules === 'function'
        ? complexAnalyse.getColorRules()
        : complexAnalyse.styleRules;
      let stats:any[]=[];
      colorRules.forEach((rule:StyleRule)=>{
        stats.push({
          title: rule.label || rule.value || '',
          count: 0,
          sum: 0,
          numericCount: 0,
          value: 0,
          color: this.getRuleColor(rule),
        });
      });
      features.forEach((item: any) => {
        colorRules.forEach((rule:StyleRule,index:number)=>{
          if(rule.evaluateFeature(item)){
            stats[index].count+=1;
            if (this.usesValueAggregation()) {
              const numericValue = this.getFeatureNumericValue(item);
              if (numericValue !== null) {
                stats[index].sum += numericValue;
                stats[index].numericCount += 1;
              }
            }
          }
        });}  );
      return stats.map((stat) => this.finalizeAggregatedStat(stat));
    }
     getCountStats(features: any, attributeName: string) {
        let productStat = features.reduce((acc: any, item: any) => {
          const key = item.get(attributeName);
    
          if (!acc[key]) {
            acc[key] = { title: key || "", count: 0, sum: 0, numericCount: 0, value: 0 };
          }
          acc[key].count += 1;
          if (this.usesValueAggregation()) {
            const numericValue = this.getFeatureNumericValue(item);
            if (numericValue !== null) {
              acc[key].sum += numericValue;
              acc[key].numericCount += 1;
            }
          }
          return acc;
        }, {} as Record<string, { title: string; count: number; sum: number; numericCount: number; value: number }>);
    
        productStat = Object.values(productStat).map((stat: any) => this.finalizeAggregatedStat(stat));
        return productStat;
    }
    /**
     * Retourne les N objets ayant les plus grandes valeurs numériques
     * de attributeName, avec libellé et couleur optionnelle (analyse thématique).
     */
    getTopNStats(features: any, layer: LayerConfig): Array<{
      label: string;
      value: number;
      featureKey: string;
      color?: string;
      category?: string;
    }> {
      const limit = Math.max(1, Number(this.topCount) || 5);
      const labelAttr = this.labelAttribute || this.attributeName;
      const ranked = (features || [])
        .map((feature: any, index: number) => {
          const raw = feature.get(this.attributeName);
          const value = Number(raw);
          if (!Number.isFinite(value)) {
            return null;
          }
          const labelRaw = feature.get(labelAttr);
          const label = labelRaw != null && labelRaw !== '' ? String(labelRaw) : 'Sans nom';
          let color: string | undefined;
          let category: string | undefined;
          if (this.useColorFromAnalyse && layer && layer.complexStyle && layer.complexStyle.isDefined()) {
            const colorRules = typeof layer.complexStyle.getColorRules === 'function'
              ? layer.complexStyle.getColorRules()
              : layer.complexStyle.styleRules;
            const matched = (colorRules || []).find((rule: StyleRule) => rule.evaluateFeature(feature));
            if (matched) {
              color = this.getRuleColor(matched);
              category = matched.label || matched.value || undefined;
            }
          }
          const featureId = typeof feature.getId === 'function' ? feature.getId() : null;
          const featureKey = feature.ol_uid != null
            ? `ol:${feature.ol_uid}`
            : (featureId != null && featureId !== '' ? `id:${featureId}` : `idx:${index}`);
          return { label, value, featureKey, color, category };
        })
        .filter((entry: any) => entry != null)
        .sort((a: any, b: any) => b.value - a.value)
        .slice(0, limit);
      return ranked;
    }

 getMinMaxMeanStats(features: any, attributeName: string):IStat {
    let productStat = features.reduce((acc: any, item: any) => {
      const key = item.get(attributeName);
      let value = Number(key)
      if (!Number.isFinite(value)) {
        return acc;
      }
      if (!acc["count"]) {
        acc["count"] = 0;
        acc["min"] = value;
        acc["max"] = value;
        acc["sum"] = 0;
        acc["mean"] = 0;
      }
      acc["count"] += 1;
      acc["sum"] += value;
      if (value < acc["min"]) {
        acc["min"] = value;
      }
      if (value > acc["max"]) {
        acc["max"] = value;
      }
      return acc;
    }, {} as Record<string, { title: string; count: number }>);

    if (!productStat.count) {
      return {min:0,max:0,mean:0,count:0,sum:0} as IStat;
    }
    productStat.mean = productStat.sum / productStat.count;
    productStat.sum = +productStat.sum.toFixed(2);
    productStat.min = +productStat.min.toFixed(2);
    productStat.max = +productStat.max.toFixed(2);
    productStat.mean = +productStat.mean.toFixed(2);
    return productStat;
  }
    clone() {
      return new Indicator(this.toJson());
    }
    
   

    toJson(): any {
      return {
        attributeName: this.attributeName,
        labelAttribute:this.labelAttribute,
        valueAttribute: this.valueAttribute,
        aggregationType: this.aggregationType || 'count',
        centerUnit: this.centerUnit,
        topCount: this.topCount || 5,
        label: this.label,
        active: this.active !== false,
        useColorFromAnalyse:this.useColorFromAnalyse,
        textContent:this.textContent,
        showCenterObject:this.showCenterObject,
        textSelectContent:this.textSelectContent,
        nbColors:this.nbColors,
        graphType: this.graphType,
        colorPalette: this.colorPalette,
      };
    }
}
